class CartMinOrderGate {
  static bind(options = {}) {
    const root = options.root || document;
    const form = options.form || null;
    const checkoutSelector = options.checkoutSelector || '[name="checkout"]';
    const modalId = options.modalId || 'Cart-MinOrderModal';
    const onAfterClose = options.onAfterClose || null;

    if (root.dataset.minOrderGateBound === 'true') {
      return root._cartMinOrderGate || null;
    }

    const openModal = (opener) => {
      const modal = document.getElementById(modalId);
      if (!modal || typeof modal.show !== 'function') return;

      const progress = root.querySelector('.cart-shipping-progress');
      const message = progress?.getAttribute('data-min-order-message') || '';
      const messageTarget = modal.querySelector('[data-min-order-message-target]');
      if (messageTarget) messageTarget.textContent = message;

      const continueButton = modal.querySelector('[data-min-order-continue]');
      if (continueButton && continueButton.dataset.bound !== 'true') {
        continueButton.dataset.bound = 'true';
        continueButton.addEventListener('click', () => {
          modal.hide();
          if (typeof onAfterClose === 'function') onAfterClose();
        });
      }

      modal.show(opener || root.querySelector(checkoutSelector));
    };

    const shouldBlock = () => {
      const progress = root.querySelector('.cart-shipping-progress');
      if (!progress) return false;
      return progress.getAttribute('data-min-order-met') === 'false';
    };

    const onCheckoutClick = (event) => {
      const checkoutButton = event.target.closest(checkoutSelector);
      if (!checkoutButton) return;
      if (!shouldBlock()) return;
      event.preventDefault();
      openModal(checkoutButton);
    };

    root.addEventListener('click', onCheckoutClick);

    if (form) {
      form.addEventListener('submit', (event) => {
        const submitter = event.submitter;
        const isCheckout =
          !submitter ||
          submitter.matches?.(checkoutSelector) ||
          submitter.getAttribute('name') === 'checkout';
        if (!isCheckout) return;
        if (!shouldBlock()) return;
        event.preventDefault();
        openModal(submitter || form.querySelector(checkoutSelector) || root.querySelector(checkoutSelector));
      });
    }

    const api = { shouldBlock, openModal };
    root.dataset.minOrderGateBound = 'true';
    root._cartMinOrderGate = api;
    return api;
  }
}

window.CartMinOrderGate = CartMinOrderGate;

document.addEventListener('DOMContentLoaded', () => {
  const footer = document.getElementById('main-cart-footer');
  if (!footer) return;

  CartMinOrderGate.bind({
    root: footer,
    form: document.getElementById('cart'),
    checkoutSelector: '#Cart-Checkout, .cart__checkout-button[name="checkout"]',
    modalId: 'Cart-MinOrderModal',
  });
});
